import React from 'react';
import { Menu, Transition } from '@headlessui/react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { User, LogOut, ChevronDown } from 'lucide-react';
import './UserProfileDropdown.css';

export const UserProfileDropdown: React.FC = () => {
  const navigate = useNavigate();
  const { profile, logout } = useAuth();

  const handleLogout = () => {
    logout();
  };

  const handleProfileClick = () => {
    navigate('/profile');
  };

  const userInitials = profile
    ? `${profile.firstName?.charAt(0) || ''}${profile.lastName?.charAt(0) || ''}`
    : 'U';

  return (
    <div className="user-profile-dropdown-wrapper">
      <Menu>
        <Menu.Button
          className="user-profile-dropdown-trigger"
          aria-label="User menu"
          title="User menu"
        >
          <ChevronDown className="user-profile-dropdown-icon" size={18} />
        </Menu.Button>

        <Transition
          enter="transition ease-out duration-200"
          enterFrom="opacity-0 scale-95 translate-y-[-10px]"
          enterTo="opacity-100 scale-100 translate-y-0"
          leave="transition ease-in duration-150"
          leaveFrom="opacity-100 scale-100 translate-y-0"
          leaveTo="opacity-0 scale-95 translate-y-[-10px]"
        >
          <Menu.Items className="user-profile-dropdown-menu">
            {/* User Info Header */}
            <div className="user-profile-dropdown-header">
              <div className="user-profile-dropdown-header-avatar">
                {userInitials}
              </div>
              <div className="user-profile-dropdown-header-info">
                <div className="user-profile-dropdown-header-name">
                  {profile?.firstName} {profile?.lastName}
                </div>
                <div className="user-profile-dropdown-header-email">
                  {profile?.email}
                </div>
              </div>
            </div>

            {/* Menu Items */}
            <div className="user-profile-dropdown-items">
              <Menu.Item>
                {({ active, close }: { active: boolean; close: () => void }) => (
                  <button
                    onClick={() => {
                      handleProfileClick();
                      close();
                    }}
                    className={`user-profile-dropdown-item ${active ? 'active' : ''}`}
                  >
                    <User className="user-profile-dropdown-item-icon" size={18} />
                    <span className="user-profile-dropdown-item-label">View Profile</span>
                  </button>
                )}
              </Menu.Item>

              <div className="user-profile-dropdown-divider" />

              <Menu.Item>
                {({ active, close }: { active: boolean; close: () => void }) => (
                  <button
                    onClick={() => {
                      handleLogout();
                      close();
                    }}
                    className={`user-profile-dropdown-item ${active ? 'active' : ''} logout-item`}
                  >
                    <LogOut className="user-profile-dropdown-item-icon" size={18} />
                    <span className="user-profile-dropdown-item-label">Logout</span>
                  </button>
                )}
              </Menu.Item>
            </div>
          </Menu.Items>
        </Transition>
      </Menu>
    </div>
  );
};
